import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  section: css`
    display: flex;
    padding: 0px 16px 0px 16px;
    flex-direction: column;
  `,
  description: css`
    padding-bottom: 8px;
    padding-top: 8px;
  `,
  infoContainer: css`
    padding-bottom: 24px;
  `,
  info: css`
    display: flex;
    align-items: center;
    color: ${colors.prussian};
    padding-top: 16px;
  `,
  infoText: css`
    padding-left: 16px;
    text-decoration: none;
  `,
  link: css`
    color: ${colors.jungle};
    text-decoration: underline;
  `,
  flyersContainer: css`
    padding: 16px 0px 32px;
  `,
  divider: css`
    margin: 16px 0px 8px 0px;
  `,
  orgNameTitle: css`
    display: flex;
    justify-content: space-between;
  `,
  sectionTitle: css`
    position: sticky;
    z-index: 1;
    transition: top 0.2s ease-out;
    background: ${colors.white};
    color: ${colors.prussian};
  `,
  flyerSection: css`
    border-top: 3px solid ${colors.silver};
    padding-bottom: 16px;
  `,
  tagsContainer: css`
    display: flex;
    gap: 8px;
    padding: 16px 0px;
  `,
};

export default styles;
